export default {
  'Account Settings': 'Configurações',
  'Change Slides': 'Trocar Apresentação de Slides',
  'Custom Venues': 'Ambientes Personalizados',
  'Download Slides': 'Baixar Slides',
  'E-mail': 'E-mail',
  'Enter the email for the person you wish to send the recording':
    'Digite o email da pessoa que vai receber a sua apresentação',
  'Feedback requested successfully!': 'Feedback solicitado com sucesso!',
  'Feedback sent successfully!': 'Feedback enviado com sucesso!',
  'Get Shareable Link': 'Copiar link para compartilhar',
  'Give feedback': 'Enviar feedback',
  'My Training': 'Meu Treinamento',
  'My account': 'Minha conta',
  'No deck used.': 'Você não selecionou nenhuma apresentação de slides.',
  'Open drawer': 'Abrir menu',
  'Presentation Recorder': 'Gravador de Apresentações',
  'Presentation successfully sent!': 'Apresentação enviada com sucesso',
  'Processing recording...': 'Processando gravação...',
  'Recording duration': 'Duração da gravação',
  'Request feedback from a Panic Lobster Mentor':
    'Pedir feedback para os mentores da Panic Lobster',
  'Request feedback': 'Pedir feedback',
  'Select the Slides': 'Selecione sua apresentação de slides',
  'Select the recording duration': 'Selecione o tempo da sua gravação',
  'Select...': 'Selecione...',
  'Send Recording': 'Enviar gravação',
  'Send by email': 'Enviar por e-mail',
  'Send presentation': 'Enviar apresentação',
  'Team Settings': 'Time',
  'Toggle light/dark theme': 'Alternar tema claro/escuro',
  'Write a message': 'Escreva uma mensagem',
  'Write your feedback!': 'Escreva ',
  'Your email': 'Seu e-mail',
  'Your name': 'Seu nome',
  'email@example.com': 'email@exemplo.com',
  Answer: 'Responder',
  Back: 'Voltar',
  Cancel: 'Cancelar',
  Close: 'Fechar',
  Continue: 'Continuar',
  Email: 'E-mail',
  Feedback: 'Feedback',
  Help: 'Ajuda',
  Logout: 'Sair',
  Message: 'Mensagem',
  Name: 'Nome',
  New: 'Novo',
  Pause: 'Pausar',
  Play: 'Ouvir',
  Record: 'Gravar',
  Recording: 'Gravação',
  Recordings: 'Gravações',
  Restart: 'Recomeçar',
  Save: 'Salvar',
  Send: 'Enviar',
  Settings: 'Configurações',
  Slides: 'Slides',
  Stop: 'Parar',
  Team: 'Time',
  Unlimited: 'Ilimitado',
}
